import React from 'react';
import styled from 'styled-components';
import Button from 'antd/es/button';
import { Link } from '@allenai/varnish-react-router';
import { DeleteOutlined, EditOutlined, EyeOutlined } from '@ant-design/icons';
import Popconfirm from 'antd/es/popconfirm';

interface TableActionsProps {
    assetLabel: string;
    recordId: string;
    asset: string;
    onDelete: () => void;
}

export const TableActions = ({ assetLabel, recordId, onDelete, asset }: TableActionsProps) => {
    return (
        <ButtonGrid>
            <ActionButton>
                <EyeOutlined aria-hidden />
                <ActionLink to={`${asset}/${recordId}`}>View</ActionLink>
            </ActionButton>
            <ActionButton>
                <EditOutlined aria-hidden />
                <ActionLink to={`${asset}/${recordId}/edit`}>Edit</ActionLink>
            </ActionButton>
            <Popconfirm
                title={() => (
                    <span>
                        Permanently delete this {assetLabel}.<br />
                        Are you sure?
                    </span>
                )}
                onConfirm={onDelete}
                okText="Yes">
                <Button type="link">
                    <DeleteOutlined aria-hidden /> Delete
                </Button>
            </Popconfirm>
        </ButtonGrid>
    );
};

const ActionButton = styled.div`
    color: ${({ theme }) => theme.palette.primary.default};
    padding: ${({ theme }) => theme.spacing.xs} ${({ theme }) => theme.spacing.md};
`;

const ActionLink = styled(Link)`
    padding-left: ${({ theme }) => theme.spacing.xs};
    &:hover {
        text-decoration: none;
    }
`;

const ButtonGrid = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    justify-items: left;
`;
